import { ActionModal } from "../../../components/modal/action-modal";
import type { DeleteEGiftCardInfoResponse } from "../types/eGiftCard.types";
import DeleteEGiftCardConfirmModal from "./DeleteEGiftCardConfirmModal";
import RestockEGiftCardForm from "./RestockEGiftCardForm";

type EGiftCardModalsProps = {
  restockEGiftCardId: string | null;
  onCloseRestock: () => void;
  onRestockSuccess: () => void | Promise<void>;
  deleteModal: {
    open: boolean;
    data: DeleteEGiftCardInfoResponse | null;
    loading: boolean;
  };
  onCloseDelete: () => void;
  onConfirmDelete: () => void;
};

const EGiftCardModals = ({
  restockEGiftCardId,
  onCloseRestock,
  onRestockSuccess,
  deleteModal,
  onCloseDelete,
  onConfirmDelete,
}: EGiftCardModalsProps) => (
  <>
    <ActionModal
      open={Boolean(restockEGiftCardId)}
      onClose={onCloseRestock}
      content={restockEGiftCardId ? (
        <RestockEGiftCardForm eGiftCardId={restockEGiftCardId} onClose={onCloseRestock} onSuccess={onRestockSuccess} />
      ) : null}
    />
    <DeleteEGiftCardConfirmModal
      open={deleteModal.open}
      onClose={onCloseDelete}
      onConfirm={onConfirmDelete}
      data={deleteModal.data}
      loading={deleteModal.loading}
    />
  </>
);

export default EGiftCardModals;
